module.exports = __webpack_public_path__ + "static/media/pic1.9a339f90.jpg";